import { __decorate } from "tslib";
import Avatar from '@/components/Avatar.vue';
import Money from '@/components/Money.vue';
import Phone from '@/components/Phone.vue';
import TagPills from '@/components/TagPills.vue';
import TransactionsModal from '@/components/TransactionsModal.vue';
import PermissionCheck from '@/plugins/PermissionCheck.vue';
import CallButton from '@/components/VoIP/CallButton.vue';
import ModalMixin from '@/mixins/modal-mixin';
import InvoiceCheckoutModal from '@/Pages/Easy/Modal.vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { mapActions, mapGetters, mapState } from 'vuex';
import DocumentViewModal from '../Company/Documents/DocumentViewModal.vue';
import AgreementPrintModal from './Customer/AgreementModal.vue';
import DebtReturnModal from "./Customer/DebtReturnModal.vue";
import ExpressCheckoutModal from './Customer/ExpressCheckoutModal.vue';
import Navigation from './Customer/Navigation.vue';
import PrintOptions from './Customer/PrintOptions.vue';
import HealthCard from './Customer/HealthCardModal.vue';
import ExamModalNew from "./Customer/ExamModalNew.vue";
import ProfileCardPrintModal from './Customer/ProfileCardModal.vue';
import CustomerModal from './CustomerModal.vue';
let CustomerHeaderComponent = class CustomerHeaderComponent extends Mixins(ModalMixin) {
    id;
    voip = null;
    areCustomerLoading;
    findCartFromStore;
    findDocumentsFromStore;
    getCustomerFromStore;
    getMyCompanyFromStore;
    getIntegrationsFromStore;
    getIntegrations;
    getCustomer;
    getMyCompany;
    findDocuments;
    fetchCart;
    get cart() {
        return this.findCartFromStore({ query: { customerId: this.id } }).data;
    }
    get documents() {
        return this.findDocumentsFromStore().data;
    }
    get customer() {
        return this.getCustomerFromStore(this.id);
    }
    get age() {
        if (this.customer.birth_date)
            return this.$moment().diff(this.customer.birth_date, 'years');
    }
    created() {
        this.getCustomer(this.id);
        this.findDocuments();
        this.fetchCart({ query: { customerId: this.id } });
    }
    newAppointment() {
        let appointment = {
            model: {
                customerId: this.$route.params.id,
                appointmentAt: this.$moment().add(1, "day"),
            },
            _id: 'temp'
        };
        const { Appointment } = this.$FeathersVuex;
        new Appointment(appointment);
        this.openModal({ id: 'AppointmentFastModal' });
    }
    openDebtModal() {
        let details = {
            customer: this.customer,
            model: {},
            _id: 'temp'
        };
        const { Customer } = this.$FeathersVuex;
        new Customer(details);
        this.openModal({ id: 'DebtReturnModal' });
    }
    openExpressCheckout() {
        this.openModal({ id: 'ExpressCheckoutModal' });
    }
};
__decorate([
    Prop({ type: String, required: true })
], CustomerHeaderComponent.prototype, "id", void 0);
CustomerHeaderComponent = __decorate([
    Component({
        components: {
            Phone,
            Avatar,
            TagPills,
            Navigation,
            HealthCard,
            PrintOptions,
            CustomerModal,
            DocumentViewModal,
            AgreementPrintModal,
            InvoiceCheckoutModal,
            ProfileCardPrintModal,
            ExpressCheckoutModal,
            Money,
            TransactionsModal,
            DebtReturnModal,
            ExamModalNew,
            CallButton,
            PermissionCheck,
        },
        computed: {
            ...mapState('customers', { areCustomerLoading: 'isGetPending' }),
            ...mapGetters('customers', { getCustomerFromStore: 'get' }),
            ...mapGetters('documents', { findDocumentsFromStore: 'find' }),
            ...mapGetters('cart', { findCartFromStore: 'find' }),
        },
        methods: {
            ...mapActions('customers', {
                getCustomer: 'get'
            }),
            ...mapActions('documents', {
                findDocuments: 'find'
            }),
            ...mapActions('cart', {
                fetchCart: 'find'
            }),
        }
    })
], CustomerHeaderComponent);
export default CustomerHeaderComponent;
